import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import axios from "helpers/API";
import TablaMaterialUI from "componentes/TablaMaterialUI";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import { errorBackendMsg, peticionBase } from "helpers/helpers";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: "relative",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog({ show = false, handleShow, id = false }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    // API Mensaje
    const [mensajeError, setMensajeError] = React.useState("");
    const [showError, setShowError] = React.useState(false);

    React.useEffect(() => {
        if (show) {
            setOpen(true);
            handleShow(false);
        }
    }, [show]);

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        if (id) {
            getDetalles(id);
        }
    }, [id]);

    const parsearFechaParaDateNativo = (fecha) => {
        // Fecha backend viene de esta manera
        const partes = fecha.split("/");
        const day = partes[0];
        const month = partes[1];
        const age = partes[2];
        return `${month}/${day}/${age}`;
    };

    const crearObjetoDateTime = (fecha, hora) => {
        const espacio = " ";
        // Date no entiende template string
        return new Date(parsearFechaParaDateNativo(fecha) + espacio + hora);
    };

    const getDetalles = (id) => {
        axios
            .post("/programaciones/obtenerDetalles", { id: id })
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    // Le agrego id por ser obligatorio para la tabla
                    const detalles = response.data.map((detalle, index) => {
                        return {
                            ...detalle,
                            id: index,
                            fechaHora: crearObjetoDateTime(
                                detalle.fechaTurno,
                                detalle.horaTurno
                            ),
                        };
                    });
                    setRows(detalles);
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const parsearFechaADate = (fecha) => {
        const partes = fecha.split("/");
        const day = Number(partes[0]);
        const month = Number(partes[1]) - 1; // the month is 0-indexed
        const age = Number(partes[2]);
        return new Date(age, month, day);
    };

    /**
     * @param {String} name Nombre del atributo
     */
    const ordenarFechas = (param1, param2, name) => {
        let dato1 = param1.api.getCellValue(param1.id, name);
        let dato2 = param2.api.getCellValue(param2.id, name);
        return parsearFechaADate(dato1) - parsearFechaADate(dato2);
    };

    const columns = [
        { field: "id", headerName: "ID", hide: true, flex: 0.4 },
        {
            headerName: "Fecha - Hora",
            field: "fechaHora",
            type: "dateTime",
            hide: true,
            minWidth: 30,
            flex: 1,
            editable: false,
        },
        {
            headerName: "Servidor",
            field: "servidor",
            minWidth: 30,
            flex: 1,
            editable: false,
        },
        {
            headerName: "Cant. Turnos",
            field: "cantTurnos",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            headerName: "Fecha Turno",
            field: "fechaTurno",
            valueGetter: (params) => params.row.fechaTurno,
            sortComparator: (v1, v2, param1, param2) =>
                ordenarFechas(param1, param2, "fechaTurno"),
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            headerName: "Hora Turno",
            field: "horaTurno",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            headerName: "Turnos tomados",
            field: "cantTurnosTomados",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            headerName: "Activo",
            field: "activo",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
    ];

    return (
        <div>
            <Dialog
                // @disableEnforceFocus hace que funcione el filtro dentro de Dialog
                disableEnforceFocus
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            Detalle Programación
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </Toolbar>
                </AppBar>
                <APIMensajeMUI
                    mb={30}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                <TablaMaterialUI
                    columnas={columns}
                    filas={rows}
                    sortModel={{
                        field: "fechaHora",
                        sort: "asc",
                    }}
                    cargando={false}
                />
            </Dialog>
        </div>
    );
}

export default FullScreenDialog;
